module.exports = ".product-thumb {\n  cursor: pointer; }\n"